<script>
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-gallery-form',

    components: { VueEditor },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    computed:
    {
        ...mapGetters({locale: 'generalCurrentLocale',}),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.images.push(file)
        },

        addFileFirst(file)
        {
            this.model.images.unshift(file)
        },

        addCover(file)
        {
            if (file && file.id)
                this.model.cover_id = file.id
            else
                this.model.cover_id = null
            this.model.cover = file
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.images.length; ++i)
            {
                const item = this.model.images[i]
                if (file.id == item.id)
                {
                    this.model.images.splice(i, 1)
                }
            }

        },

        addVideo(file)
        {
            this.model.videos.push(file)
        },

        removeVideo(index)
        {
            this.model.videos.splice(index, 1)
        }
    },

    data()
    {
        return {
            editorSettings: {
                imageResize: {},
            },
        }
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.TITLE') }}
            </label>
            <div class="col-md-4">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.title">
                </div>
            </div>
            <div class="col-md-4">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.title_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.SLUG') }}
            </label>
            <div class="col-md-8">
                <input type="text" class="form-control" v-model="model.slug">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-4">
                <label class="control-label">
                    {{ $t('GENERAL.GALLERY_YEAR') }}
                </label>
                <input type="number" class="form-control" v-model="model.year">
            </div>
            <div class="col-md-4">
                <label class="control-label">
                    {{ $t('GENERAL.GALLERY_DAY') }}
                </label>
                <input type="number" class="form-control" v-model="model.day">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.COVER_IMAGE') }}
            </label>
            <div class="col-md-8">
                <label class="btn btn-sm btn-primary">
                    <mv-uploader ref="uploader" multiple @upload-done="addCover($event)" accept="image/*" type="cover"></mv-uploader>
                    <icon name="picture-o"></icon>
                </label>
            </div>
        </div>

        <div class="form-group row" v-if="model.cover">
            <div class="col-md-4">

            </div>
            <div class="col-md-8">
                <mv-attachment :attachment="model.cover">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <label class="btn btn-sm btn-primary">
                    <mv-uploader ref="uploader2" multiple @upload-done="addFile($event)" accept="image/*" type="media"></mv-uploader>
                    <icon name="file"></icon>
                </label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.images" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">
                <label>
                    {{ $t('GENERAL.VIDEO') }}
                </label>
            </div>
            <div class="col-md-6">
                <mv-video @upload-done="addVideo($event)">
                </mv-video>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <div v-for="(index, video) in model.videos" :key="video.id" class="row">
                    <div class="col-sm-10">
                        <iframe  width="320" height="160" :src="'https://www.youtube.com/embed/' + video.video" allowFullScreen="true">

                        </iframe>
                    </div>
                    <div class="col-sm-2 vertical-align-video" @click.prevent.stop="removeVideo(index)">
                        <button class="btn btn-danger btn-xs">&times;</button>
                    </div>
                </div>
            </div>

        </div>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/GalleryForm.vue